import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { SCIApi } from 'src/apis';
import { Point } from 'src/types/Point';

import {
    getShuttlePoints as getShuttlePointsApiPath,
    hasShuttles as hasShuttlesApiPath,
} from '../updateCustomerInfo.api';

const getShuttlePoints = async () => {
    const apiCalls = SCIApi.getInstance();
    const result: AxiosResponse<Point[]> = await apiCalls.get<Point[]>(
        getShuttlePointsApiPath,
    );

    return result?.data ?? result;
};

export const hasShuttles = async (): Promise<boolean> => {
    const apiCalls = SCIApi.getInstance();
    const result: AxiosResponse<{ hasShuttles: boolean }> = await apiCalls.get<{
        hasShuttles: boolean;
    }>(hasShuttlesApiPath);

    return (result.data ?? result)?.hasShuttles ?? false;
};

export const useGetShuttleServicePointsKey = 'useGetShuttleServicePointsKey';

export const useGetShuttleService = () => {
    const { isLoading, data: shuttlePoints } = useQuery({
        queryKey: [useGetShuttleServicePointsKey],
        queryFn: getShuttlePoints,
    });

    return { shuttlePoints, isLoading };
};

export const useHasShuttleServiceKey = 'useHasShuttleServiceKey';

export const useHasShuttle = () => {
    const { isLoading, data } = useQuery({
        queryKey: [useHasShuttleServiceKey],
        queryFn: hasShuttles,
    });

    return { hasShuttles: data, isLoading };
};
